import React from "react";
import Header from "../../components/Header"; 
import Footer from "../../components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import WishlistRight from "../Layouts/WishlistRight";



export default function Wishlist() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <WishlistRight />

       </div>
      </div>

 
      <Footer />
    </div>
  );
}

